import React, {FC, useEffect, useRef, useState} from 'react'
import {Button} from '@dv5/components'
import {DvDocument} from '@dv5/domain'
import {getAvailableDocuments, validateDocumentSelection} from './changePartDocumentHelpers'
import './ChangePartDocumentDialog.less'

interface Props {
    currentDocumentId: string
    documents: Array<DvDocument>
    onConfirm: (newDocumentId: string) => void
    onCancel: () => void
}

export const ChangePartDocumentDialog: FC<Props> = ({
                                                        currentDocumentId,
                                                        documents,
                                                        onConfirm,
                                                        onCancel,
                                                    }) => {
    const availableDocuments = getAvailableDocuments(documents, currentDocumentId)
    const [selectedDocumentId, setSelectedDocumentId] = useState('')
    const [errorMessage, setErrorMessage] = useState('')
    const dialogRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                e.preventDefault()
                onCancel()
            }
        }
        document.addEventListener('keydown', handleKeyDown)
        return () => document.removeEventListener('keydown', handleKeyDown)
    }, [onCancel])

    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (dialogRef.current && !dialogRef.current.contains(e.target as Node)) {
            onCancel()
        }
    }

    const handleDocumentChange = (value: string) => {
        setSelectedDocumentId(value)
        if (errorMessage) {
            setErrorMessage('')
        }
    }

    const handleConfirm = () => {
        const error = validateDocumentSelection(selectedDocumentId, currentDocumentId)
        if (error) {
            setErrorMessage(error)
            return
        }
        onConfirm(selectedDocumentId)
    }

    const handleCancel = () => {
        setSelectedDocumentId('')
        setErrorMessage('')
        onCancel()
    }

    return (
        <div className="change-part-document-dialog-overlay" onClick={handleOverlayClick}>
            <div className="change-part-document-dialog" ref={dialogRef}>
                <h3>Move to document</h3>
                <div className="document-select-container">
                    <label className="label" htmlFor="changePartDocumentId">Document:</label>
                    <select
                        id="changePartDocumentId"
                        className="document-select"
                        value={selectedDocumentId}
                        onChange={e => handleDocumentChange(e.target.value)}
                        autoFocus
                    >
                        <option value="">Select a document...</option>
                        {availableDocuments.map(document => (
                            <option key={document.id} value={document.id}>{document.title}</option>
                        ))}
                    </select>
                </div>
                {errorMessage && (
                    <div className="error-message">{errorMessage}</div>
                )}
                <div className="buttons">
                    <Button title="Cancel" onClick={handleCancel} className="cancel-dialog-button"/>
                    <Button title="Move" onClick={handleConfirm} className="move-dialog-button"/>
                </div>
            </div>
        </div>
    )
}